class TabSwitcher extends HTMLElement {
  constructor() {
    super();
    this.tabableSections = document.querySelectorAll('.tabable-section');
  }

  connectedCallback() {
    if(!this.tabableSections && !this.classList.contains('design_mode')) {
      this.classList.add('hidden');
      return
    };
    this.addEventListener('click', (e) => {
      if(e.target.tagName === 'BUTTON') this.handleClick(e)
    });
  }

  handleClick(event) {
    const activeTabIdentifier = event.target.dataset.loopIndex == '1' ? 'first' : 'second';
    this.querySelector(".active").classList.remove('active');
    event.target.classList.add('active');

    this.tabableSections.forEach((section) => {
      if(section.classList.contains(`tabable-section--${activeTabIdentifier}`)) {
        section.classList.remove('hidden');
      } else {
        section.classList.add('hidden');
      }
    })
  }

}

if (!customElements.get('tab-switcher')) customElements.define('tab-switcher', TabSwitcher);